/**************************************************
 * Nombre:       Tarjeta_Look
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Badge, Box, Button, CircularProgress, Drawer, Grid, IconButton, Typography} from "@mui/material";
import {CloseOutlined, ShoppingBagOutlined, ShoppingCartOutlined} from "@mui/icons-material";
import {useEffect, useState} from "react";
import {motion} from 'framer-motion';
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";
import Tarjetas_Producto_Look from "./Tarjetas_Producto_Look";
import {useFuncionesCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useFuncionesCarritoLateral";
import {useCarritoLateral} from "../../Modulo_Carrito_Lateral/Hooks/useCarritoLateral";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";
import {NEGRITA} from "../../Constantes";

const Tarjeta_Look = ({item}) => {
    const {sCell} = useResponsive()
    const [entro, setEntro] = useState(false)
    const [open, setOpen] = useState(false);
    const [productos, setProductos] = useState([])
    const [consulto, setConsulto] = useState(false)
    const {productos: prodCarrito} = useFuncionesCarritoLateral()
    const {abrir: abrirCarrito, cerrar: cerrarCarrito, Carrito} = useCarritoLateral()

    const abrir = () => {
        setOpen(true);
    }

    const cerrar = () => {
        setOpen(false);
    }

    const obtenerProductos = async () => {

        setConsulto(true)
        let arr = []
        let ids = item.productos
        if (ids) {
            for (let id of ids) {
                let doxProd = await obtenerDoc('productos', id)
                if (doxProd.res) {
                    arr.push(doxProd.data)
                }
            }
            setConsulto(false);
        }
        setConsulto(false);
        setProductos(arr)
    }

    useEffect(() => {

        if (open && productos.length === 0) {
            obtenerProductos().then(res => {
            })

        }

    }, [open]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            onMouseOver={() => setEntro(true)}
            onMouseLeave={() => setEntro(false)}
            sx={{
                backgroundImage: `url(${item.img})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'center center',
                p: 3,
                transition: 'all .2s ease-in-out',

            }}
        >

            <Carrito/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end', mt: 52}}>
                <Box
                    sx={{
                        backgroundColor: '#00000080',
                        border: 1,
                        borderColor: '#fff',
                        backdropFilter: 'blur(2px)',
                        boxShadow: 0,
                        px: 1,
                        borderRadius: 8,
                        transition: 'all .2s ease-in-out',
                    }}
                >
                    <IconButton
                        onClick={() => setOpen(true)}

                        sx={{
                            transition: 'all .2s ease-in-out',
                        }}
                    >
                        <ShoppingBagOutlined sx={{fill: '#fff'}}/>

                        {entro &&
                            <motion.div
                                initial={{opacity: 0, y: -20}} // Estado inicial (oculto)
                                animate={{opacity: 1, y: 0}}    // Estado animado (visible)
                                exit={{opacity: 0, y: -20}}     // Estado al desmontarse
                                transition={{duration: 0.5}}    // Duración de la animación

                            >
                                <Typography sx={{mt: 0.3, fontSize: 14, pl: 1, color: '#fff'}}>Comprar el
                                    Look</Typography>
                            </motion.div>
                        }
                    </IconButton>


                </Box>
            </Grid>

            <Drawer
                open={open}
                anchor={'right'}
                onClose={() => setOpen(false)}
                sx={{
                    width: sCell ? 370 : 500
                }}
                slotProps={{
                    paper: {
                        sx: {
                            width: sCell ? 370 : 500,
                            backgroundColor: 'transparent', // Para que no se vea el fondo sólido mientras hace fade
                            boxShadow: 'none',
                        }
                    }
                }}>

                <Box sx={{
                    width: '100%',
                    height: '100%',
                    bgcolor: 'background.paper',

                }}>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}}
                              sx={{
                                  justifyContent: 'space-between',
                                  textAlign: 'center',
                                  px: 3,
                                  py: 2,
                              }}>

                            <Grid container size={{xs: 10, sm: 10, md: 10}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontWeight: 800, fontFamily: NEGRITA, fontSize: 28}}>
                                    AGREGA EL LOOK
                                </Typography>
                            </Grid>

                            <Grid container size={{xs: 2, sm: 2, md: 2}} sx={{justifyContent: 'flex-end'}}>
                                <IconButton
                                    onClick={() => setOpen(false)}
                                    sx={{p: 0}}>
                                    <CloseOutlined/>
                                </IconButton>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{textAlign: 'left', lineHeight: 1.2, fontSize: 14}}>Estas son las
                                    prendas que componen el look, escoge
                                    tu talla y agregalas al
                                    carrito</Typography>
                            </Grid>


                        </Grid>

                    </Grid>

                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{px: 3, mt: 2}}
                    >

                        {consulto &&

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <CircularProgress/>
                            </Grid>
                        }

                        {productos.map((it, index) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Tarjetas_Producto_Look item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2, px: 3}}>
                        <Button
                            onClick={() => abrirCarrito()}
                            startIcon={
                                <Badge
                                    color="primary"
                                    badgeContent={prodCarrito.length}
                                    anchorOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                >
                                    <ShoppingCartOutlined/>

                                </Badge>}
                            variant={'outlined'} sx={{py: 1.2}} fullWidth>

                            Ver Carrito


                        </Button>
                    </Grid>


                </Box>


            </Drawer>


        </Grid>
    )

}
export default Tarjeta_Look